import React, { Component } from "react"

/* Constants */
import { utils, sound, env } from '../constants'

/* UUID */
import { v4 as uuidv4 } from 'uuid'

/* Components */
import { Picture, Chip } from "@cuba-go/poker-ui"
import { CHOICE } from "../constants/status"

import VipRates from "./VipRates"


class Bet extends Component {

    constructor() {
        super()
        this.state = {
            history: [],
        }
    }


    // ─────────────────────────────────────────────────────────────
    // Helpers
    // ─────────────────────────────────────────────────────────────

    countTruthy = (array) => array.filter(Boolean).length

    getChipsList = () => utils.getChips(this.props.chips)

    /* Sum of all placed BONUS bets */
    totalBonus = () => {
        const { bonus } = this.props

        let total = 0

        if (Array.isArray(bonus)) {
            bonus.forEach(item => { if (item) total += parseInt(item) })
        }

        return total
    }


    // ─────────────────────────────────────────────────────────────
    // Bet actions
    // ─────────────────────────────────────────────────────────────

    /* Add chip to a box */
    add = (number) => {
        const { history } = this.state
        const { setAnte, ante, balance, toggleBalanceError, activeChip, max, toggleMaxBetError } = this.props

        const chipsList = this.getChipsList()
        const chipIndex = chipsList.findIndex(c => c.key === activeChip)
        if (chipIndex === -1) return

        const current = chipsList[chipIndex]
        const current_ante = ante[number] || 0

        /* Ставка, которая встанет на этот бокс */
        const target = current_ante + current.value

        /* setAnte выравнивает боксы по максимуму, поэтому резерв считаем по итоговой
           ставке бокса, а не по той, что стояла раньше: чип больше текущей ставки
           поднимает оба бокса, и проверять надо уже новое значение */
        let activeBoxes = 0
        let otherAnte = 0

        ante.forEach((item, index) => {
            const value = parseInt(item) || 0

            if (value > 0 || index === number) activeBoxes += 1
            if (index !== number && value > otherAnte) otherAnte = value
        })

        const ante_to_check = Math.max(target, otherAnte)

        if (
            balance === null || balance === undefined ||
            parseInt(balance) === 0 ||
            parseInt(balance) < ante_to_check * activeBoxes * 4 + this.totalBonus()
        ) {
            toggleBalanceError()
            return
        }

        if (current_ante + current.value > max) {
            toggleMaxBetError()
            return
        }

        const uid = uuidv4()
        this.setState({ history: [...history, { ...current, uid, index: number, box: number, target: "ante" }] })
        setAnte({ value: current_ante + current.value, index: number })
        sound.play('sound')
    }


    /* Add chip to a box BONUS */
    addBonus = (number) => {
        const { history } = this.state
        const { setBonus, ante, bonus, balance, toggleBalanceError, activeChip, maxBonus, toggleMaxBonusError } = this.props

        /* BONUS живёт только вместе с ANTE на этом боксе */
        if (!ante[number]) {
            sound.play('blocked')
            return
        }

        const chipsList = this.getChipsList()
        const chipIndex = chipsList.findIndex(c => c.key === activeChip)
        if (chipIndex === -1) return

        const current = chipsList[chipIndex]
        const current_bonus = (bonus && bonus[number]) ? bonus[number] : 0

        let totalAnte = 0
        ante.forEach(item => { if (item) totalAnte += parseInt(item) })

        if (
            balance === null || balance === undefined ||
            parseInt(balance) === 0 ||
            parseInt(balance) < totalAnte * 4 + this.totalBonus() + current.value
        ) {
            toggleBalanceError()
            return
        }

        if (parseInt(maxBonus) > 0 && current_bonus + current.value > parseInt(maxBonus)) {
            toggleMaxBonusError()
            return
        }

        const uid = uuidv4()
        this.setState({ history: [...history, { ...current, uid, index: number, box: number, target: "bonus" }] })
        setBonus({ value: current_bonus + current.value, index: number })
        sound.play('sound')
    }


    /* Remove all chips */
    clear = () => {
        const { ante, setAnte, setBonus } = this.props

        if (this.countTruthy(ante) > 0) {
            this.setState({ history: [] })
            setAnte('all')
            setBonus('all')
        } else {
            sound.play('blocked')
        }
    }


    /* Undo last chip */
    cancel = () => {
        const { history } = this.state
        const { setAnte, setBonus, ante, bonus } = this.props

        if (history.length === 0) {
            if (this.countTruthy(ante) > 0) {
                this.clear()
            } else {
                sound.play('blocked')
            }
            return
        }

        const last_operation = history[history.length - 1]

        if (last_operation.type === 'double') {
            last_operation.boxes.forEach(b => {
                setAnte({ value: b.value, index: b.index, cancel: true })
            })
            this.setState({ history: history.slice(0, -1) })
            sound.play('sound')
            return
        }

        const lastBox = last_operation.index

        if (last_operation.target === "bonus") {
            const bonus_value = (bonus && bonus[lastBox]) ? bonus[lastBox] : 0

            if (bonus_value > 0) {
                const result = Math.max(0, parseInt(bonus_value) - parseInt(last_operation.value))
                this.setState({ history: history.slice(0, -1) })
                setBonus({ value: result, index: lastBox })
                sound.play('sound')
            }
            else {
                /* BONUS уже снят вместе с ANTE — просто убираем запись из истории */
                this.setState({ history: history.slice(0, -1) }, () => this.cancel())
            }

            return
        }

        const ante_value = ante[lastBox]

        if (ante_value > 0) {
            const result = Math.max(0, parseInt(ante_value) - parseInt(last_operation.value))
            this.setState({ history: history.slice(0, -1) })
            setAnte({ value: result, index: lastBox, cancel: true })
            sound.play('sound')
        } else {
            sound.play('blocked')
        }
    }


    /* Double bet for all active boxes */
    double = () => {
        const { history } = this.state
        const { setAnte, ante, balance, toggleBalanceError } = this.props

        let totalBet = 0
        ante.forEach(item => { if (item) totalBet += parseInt(item) })

        if (
            balance === null || balance === undefined ||
            parseInt(balance) === 0 ||
            parseInt(balance) < totalBet * 2 * 4 + this.totalBonus()
        ) {
            toggleBalanceError()
            return
        }

        const doubleBoxes = []
        let doubled = false

        ante.forEach((ante_value, index) => {
            if (!ante_value || ante_value <= 0) return
            doubleBoxes.push({ value: ante_value, index })
            setAnte({ value: ante_value * 2, index })
            doubled = true
        })

        if (doubled) {
            this.setState({ history: [...history, { type: 'double', uid: uuidv4(), boxes: doubleBoxes }] })
            sound.play('sound')
        } else {
            sound.play('blocked')
        }
    }


    /* Repeat last bets */
    refresh = () => {
        const { setAnte, setBonus, ante, last, lastBonus, boxes, balance, toggleBalanceError, withJackpot } = this.props


        let totalAnte = 0
        let totalLast = 0
        let totalLastBonus = 0
        ante.forEach(item => { totalAnte += item })
        last.forEach(item => { totalLast += item })

        if (withJackpot && Array.isArray(lastBonus)) {
            lastBonus.forEach(item => { if (item) totalLastBonus += parseInt(item) })
        }

        if (totalLast === 0 || totalAnte > 0) {
            sound.play('blocked')
            return
        }

        if (
            balance === null || balance === undefined ||
            parseInt(balance) === 0 ||
            parseInt(balance) < totalLast * 4 + totalLastBonus
        ) {
            toggleBalanceError()
            return
        }

        if (!Array.isArray(boxes) || boxes.length === 0) {
            sound.play('blocked')
            return
        }


        setAnte({ refresh: true, lastData: last })

        if (withJackpot) {
            setBonus({ refresh: true, lastData: Array.isArray(lastBonus) ? [...lastBonus] : [0, 0] })
        }

        sound.play('sound')

    }


    /* Start game */
    play = () => {
        const { start, ante } = this.props

        let totalBet = 0
        ante.forEach(item => { totalBet += item })

        if (totalBet > 0) {
            start()
        } else {
            sound.play('blocked')
        }
    }


    /* Select chip or add to box 0 if already selected */
    setActiveChip = (item) => {
        const { activeChip, setActiveChip } = this.props

        if (item.key !== activeChip) {
            setActiveChip(item.key)
        } else {
            this.add(0)
        }
    }


    // ─────────────────────────────────────────────────────────────
    // Render helpers
    // ─────────────────────────────────────────────────────────────

    renderChips = () => {
        const { activeChip, chips } = this.props
        const list = this.getChipsList()

        return (
            <div className="chips">
                {list.map((item, index) => (
                    <div
                        key={`${index}`}
                        className={item.key === activeChip ? 'chip active-chip' : 'chip'}
                        onClick={() => this.setActiveChip(item)}
                    >
                        <Chip value={item.value} chips={chips} size={70} />
                    </div>
                ))}
            </div>
        )
    }


    // ─────────────────────────────────────────────────────────────
    // Render
    // ─────────────────────────────────────────────────────────────

    render = () => {
        const { history } = this.state
        const { ante, bonus, last, boxes, currency, activeChip, chips, withJackpot } = this.props

        const disabled = this.countTruthy(ante) === 0
        const canRefresh = this.countTruthy(last) > 0 && this.countTruthy(ante) === 0

        return (
            <div className="bet">

                <div className="bet-panel">

                    <div className="bet-buttons">
                        <div className="bet-empty-space" />

                        <div className={`bet-button ${disabled ? 'disabled' : ''}`} onClick={this.clear}>
                            <Picture src={`${env.mediapoint}/images/bet/delete.png`} alt="Delete" />
                            <span>Очистить</span>
                        </div>

                        <div className={`bet-button ${disabled ? 'disabled' : ''}`} onClick={this.cancel}>
                            <Picture src={`${env.mediapoint}/images/bet/cancel.png`} alt="Cancel" />
                            <span>Отменить</span>
                        </div>
                    </div>

                    {this.renderChips()}

                    <div className="bet-buttons">

                        <div className={`bet-button ${disabled ? 'disabled' : ''}`} onClick={this.double}>
                            <div className="bet-title">2x</div>
                            <span>Удвоить</span>
                        </div>

                        <div className={`bet-button ${!canRefresh ? 'disabled' : ''}`} onClick={this.refresh}>
                            <Picture src={`${env.mediapoint}/images/bet/refresh.png`} alt="Refresh" />
                            <span>Повторить</span>
                        </div>

                        <div className={`bet-button bet-play-button ${disabled ? 'disabled' : ''}`} onClick={this.play}>
                            <Picture src={`${env.mediapoint}/images/bet/play.png`} alt="Play" />
                            <span>Играть</span>
                        </div>

                    </div>

                </div>

                <div className="pc-rates-outer">
                    <VipRates
                        status={CHOICE}
                        currency={currency}
                        history={history}
                        fromBet={true}
                        add={(value) => this.add(value)}
                        addBonus={(value) => this.addBonus(value)}
                        result
                        boxes={boxes}
                        ante={ante}
                        bonus={bonus}
                        withJackpot={withJackpot}
                        active={activeChip}
                        bet={() => { }}
                        chips={chips}
                    />
                </div>

            </div>
        )
    }

}

export default Bet